import { html, render, type TemplateResult } from "lit-html";

let el: HTMLDivElement | null = null;

function node(): HTMLDivElement {
  if (!el) {
    el = document.createElement("div");
    el.className = "tooltip";
    el.setAttribute("role", "tooltip");
    document.body.appendChild(el);
  }
  return el;
}

export function showTip(content: TemplateResult, x: number, y: number): void {
  const t = node();
  render(content, t);
  t.classList.add("show");
  const pad = 14;
  const r = t.getBoundingClientRect();
  let left = x + pad;
  let top = y + pad;
  if (left + r.width > window.innerWidth - 8) left = x - r.width - pad;
  if (top + r.height > window.innerHeight - 8) top = y - r.height - pad;
  t.style.left = `${Math.max(8, left)}px`;
  t.style.top = `${Math.max(8, top)}px`;
}

export function hideTip(): void {
  el?.classList.remove("show");
}

export const tipRow = (label: string, value: string, color?: string) =>
  html`<div class="tt-row"><span>${color ? html`<i style="background:${color}"></i>` : null}${label}</span><b>${value}</b></div>`;
